/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import Enum from './Enum';
//@import Enum (loadtime) // superclass

/**
 * <p>Java class for treatAs. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="treatAs"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="reference"/&gt; &lt;enumeration value="alias"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
 */
export default class TreatAs extends Enum{

	enumValue = null;

	/**
	 * Specifies that the querySubject is a shortcut and is treated as a reference.
	 */
	static  REFERENCE = TreatAs.newLiteral("reference");

	/**
	 * Specifies that the querySubject is a shortcut and is treated as an alias.
	 */
	static  ALIAS = TreatAs.newLiteral("alias");



	constructor(v) {
		super(v);
		this.enumValue = v;
	}

	static fromValue(v) {
		for (var i = 0; (i < TreatAs.values().length); ++i) {
			if (TreatAs.values()[i].enumValue == v) {
				return TreatAs.values()[i];
			}
		}
		throw new Error(v);
	}

	value() {
		return this.enumValue;
	}

	getResourceId() {
		return (("TreatAs" + "_") + this.value());
	}
}


// WEBPACK FOOTER //
// ./src/generated/TreatAs.js